<template>
  <v-form v-bind="this.$attrs">
    <div>
      <v-row no-gutters>
        <v-col cols="10">
          <v-row>
            <v-col cols="4">
              <v-select
                :items="exams"
                v-model="exam"
                label="Chọn kỳ thi"
                item-value="id"
                item-text="name"
                return-object
                outlined
                dense
                clearable
                hide-details
                @change="examSelected"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="rooms"
                v-model="room"
                label="Chọn phòng thi"
                item-value="id"
                item-text="name"
                return-object
                clearable
                outlined
                dense
                hide-details
                @change="roomSelected"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="filteredSubjects ? filteredSubjects : subjects"
                v-model="subject"
                label="Chọn môn thi"
                item-value="id"
                item-text="name"
                return-object
                clearable
                outlined
                dense
                hide-details
                class="pr-6"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2">
          <v-btn
            :disabled="!exam"
            height="40"
            width="100%"
            style="background-color: white"
            color="#0D47A1"
            @click="onFilterChanged"
            outlined
          >
            Xác nhận
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {},
  data() {
    return {
      exam: '',
      room: '',
      subject: '',
      exams: [],
      subjects: [],
      rooms: [],
      filteredSubjects: []
    }
  },
  async mounted() {
    await this.getExams()
  },
  methods: {
    ...mapActions('subjectExam', ['fetchSubjects']),
    ...mapActions('room', ['fetchRooms']),
    ...mapActions('exam', ['fetchExams']),
    onFilterChanged() {
      const params = {
        exam: this.exam.id,
        rooms: this.room ? this.room.id : '',
        subjects: this.subject ? this.subject.id : ''
      }
      this.$emit('onFilterChanged', params, this.subjects, this.rooms, this.exam.type, this.exam.grade)
    },
    async getExams() {
      this.$loading.active = true
      this.exams = await this.fetchExams({ status: 'active' })
      this.$loading.active = false
    },

    async getRooms(query) {
      this.rooms = await this.fetchRooms(query)
    },
    async getSubjects(query) {
      this.subjects = await this.fetchSubjects(query)
    },
    async examSelected() {
      this.$loading.active = true
      await this.getSubjects({ exam: this.exam ? this.exam.id : '' })
      await this.getRooms({ exam: this.exam ? this.exam.id : '' })
      this.room = ''
      this.$loading.active = false
    },
    async roomSelected() {
      this.$loading.active = true
      if (this.room && this.room.subjects) {
        this.filteredSubjects = this.subjects.filter(subject =>
          this.room.subjects.some(roomSubject => roomSubject.id === subject.id)
        )
      }
      this.$loading.active = false
    }
  }
}
</script>
